import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { IExerciseLoadFormula } from '../../../../types/interfaces/exercise-load-formula';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (formula: IExerciseLoadFormula) => void,
  onDelete: (formula: IExerciseLoadFormula) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      cellReducer: (formula: IExerciseLoadFormula) => {
        return <div className={classes.nameKey}>{formula.nameKey}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.VALUE,
      cellReducer: (formula: IExerciseLoadFormula) => {
        return <div className={classes.value}>{formula.value}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PRIORITY,
      cellReducer: (formula: IExerciseLoadFormula) => {
        return <div className={classes.priority}>{formula.priority}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      cellReducer: (formula: IExerciseLoadFormula) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={formula.active}></Checkbox>
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (formula: IExerciseLoadFormula) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(formula);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(formula);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
